export const LibraryRiskSystemUpdate = ['id', 'statement', 'active'];

export const LibraryRiskOrgUpdate = [
    ...LibraryRiskSystemUpdate,
    'responsibleFunctionId',
    'libraryControlIds',
    'controlStrategyId',
    'riskCategoryId',
    'riskLibraryCategoryIds',
    'reviewFrequencyPeriod',
    'reviewFrequencyUnits',
    'displayOrder',
    'reviewRequired',
    'countries',
    'vendorIds',
];
